"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectRetentionActionsIsLoading = exports.selectRetentionActions = exports.selectOnlyRetentionActions = exports.retentionActionsSlice = exports.initialState = exports.fetchRetentionActions = exports.fetchApplyRetentionAction = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
const initialState = exports.initialState = {
  error: null,
  isLoading: false,
  isApplyLoading: false,
  retentionActions: {
    type: '',
    offerId: '',
    extensionDetails: {
      periodUnit: '',
      amount: 0
    }
  }
};
const fetchRetentionActions = exports.fetchRetentionActions = (0, _toolkit.createAsyncThunk)('fetchRetentionActions', async (offerId, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const result = await (0, _api.getRetentionActions)(offerId);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchApplyRetentionAction = exports.fetchApplyRetentionAction = (0, _toolkit.createAsyncThunk)('fetchApplyRetentionAction', async (offerId, _ref2) => {
  let {
    rejectWithValue
  } = _ref2;
  try {
    const result = await (0, _api.applyRetentionAction)(offerId);
    return result;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const retentionActionsSlice = exports.retentionActionsSlice = (0, _toolkit.createSlice)({
  name: 'retentionActions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchRetentionActions.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(fetchRetentionActions.fulfilled, (state, action) => {
      var _action$meta;
      const offerId = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.arg;
      state.isLoading = false;
      state.retentionActions = {
        ...action.payload,
        offerId
      };
    });
    builder.addCase(fetchRetentionActions.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
    builder.addCase(fetchApplyRetentionAction.pending, state => {
      state.isApplyLoading = true;
    });
    builder.addCase(fetchApplyRetentionAction.fulfilled, state => {
      state.isApplyLoading = false;
    });
    builder.addCase(fetchApplyRetentionAction.rejected, (state, action) => {
      state.isApplyLoading = false;
      if (action.payload) {
        state.error = action.payload;
      }
    });
  }
});
const selectRetentionActions = state => state.retentionActions;
exports.selectRetentionActions = selectRetentionActions;
const selectOnlyRetentionActions = state => state.retentionActions.retentionActions;
exports.selectOnlyRetentionActions = selectOnlyRetentionActions;
const selectRetentionActionsIsLoading = state => state.retentionActions.isLoading;
exports.selectRetentionActionsIsLoading = selectRetentionActionsIsLoading;
var _default = exports.default = retentionActionsSlice.reducer;